// Verificamos los datos del articulo y/o producto que se va
//  ingresamos al carrito de compra
//  e ingresamos los datos del cliente si se va realizar la compra en tienda o se envia a domicilio.
//======================================================================
// Checkout / card to buy

import useFunctionInfo from "@/Hooks/useDataInformation/useFunctionInfo";
import { useEffect, useState } from "react";
import { getIpCliente, useProductSku, useViewInfoProduct } from "../Index";
import type { MCheckout } from "@/Models/MCheckout/MCheckout";
import { mapperToBuyProduct } from "@/Mappers/BuyProduct.mapper";
import type { BasketResponse } from "@/Models/Response/BasketResponse";
import type { MBasketBuy } from "@/Models/MBasketBuy/MBasketBuy";
import { mapperToCheckoutBuy } from "@/Mappers/CheckoutProduct.mapper";
import type { OrderBuyResponse } from "@/Models/Response/OrderBuyResponse";
import type { BuyProduct, MBasket } from "@/Models/MBuyPropduct/BuyProduct";
import type { MBuyCarCheckout } from "@/Models/MBuyCarCheckout/MBuyCarCheckout";
import type { MBuyFrom } from "@/Models/MBuyFrom/MBuyFrom";

export const useCheckoutAddOrderBuy = (
  sku: string,
  category: string,
  subCategory: string,
  quantity: number
) => {
  const {
    data: response,
    loading: isPosting,
    postData,
  } = useFunctionInfo<BasketResponse>("");

  const { mDatos: productos, isLoading: isLoadingProductos } =
    useViewInfoProduct(sku, category, subCategory);

  const { productsData, isLoadings: isLoadingSku } = useProductSku(sku);

  const [MDatos, setMDatos] = useState<MCheckout[]>([]);

  const [loading, setLoading] = useState(true);

  // 1. Cuando tengamos el producto, mandamos a carrito
  useEffect(() => {
    if (!isLoadingProductos && productos?.length > 0) {
      const quantityArt = quantity > 0 ? quantity : 1;
      const buyProduct = mapperToBuyProduct(productos, quantityArt);
      postData("/Carrito", buyProduct);
    }
  }, [isLoadingProductos, productos, quantity, postData]);

  // 2. Cuando tengamos respuesta del carrito, construimos el checkout
  useEffect(() => {
    const buildCheckout = async () => {
      if (
        !isPosting &&
        response?.status === 200 &&
        //Array.isArray(productsData)
        productsData
      ) {
        try {
          const responseData: MBasketBuy = JSON.parse(response.message);
          const ipClient = await getIpCliente();
          const mappedCheckout = await mapperToCheckoutBuy(
            productsData,
            quantity,
            [responseData],
            String(ipClient)
          );
          setMDatos(mappedCheckout);
        } catch (err) {
          console.error("Error en checkout mapping", err);
        } finally {
          setLoading(false);
        }
      }
    };

    buildCheckout();
  }, [isPosting, response, productsData, quantity]);

  return {
    MDatos,
    isLoading: loading || isLoadingProductos || isLoadingSku || isPosting,
  };
};

export const useCheckoutAddOrderBuyV2 = (
  isLoadinLoad: boolean,
  addTicketProduct: MBasket[]
) => {
  const {
    data: response,
    loading: isPosting,
    postData,
  } = useFunctionInfo<BasketResponse>("");

  //const [MDatos, setMDatos] = useState<MCheckout[]>([]);
  const [responseData, setResponseData] = useState<MBasketBuy>({
    basketId: "",
    customerInfo: {
      customerId: "",
    },
  });

  const [loading, setLoading] = useState(true);

  // 1. Cuando tengamos el producto, mandamos a carrito
  useEffect(() => {
    if (!isLoadinLoad && addTicketProduct?.length > 0) {
      const OrderBuyBasket: BuyProduct = {
        skuId:
          addTicketProduct
            .flatMap((x) => x.item_id)
            .filter(Boolean)
            .join(",") ?? "",
        productItems: addTicketProduct,
      };

      postData("/Carrito", OrderBuyBasket);
    }
  }, [isLoadinLoad, addTicketProduct, postData]);

  // 2. Cuando tengamos respuesta del carrito, construimos el checkout
  useEffect(() => {
    if (!isPosting && response?.status === 200) {
      const responseD: MBasketBuy = JSON.parse(response.message);
      setResponseData(responseD);
      setLoading(false);
    }
  }, [isPosting, response]);

  return {
    MDatos: responseData,
    isLoadingCheckout: loading || isPosting,
  };
};

export const useTicketOrderBuy = () => {
  const {
    data: dataInformation,
    loading: isLoadings,
    postData,
  } = useFunctionInfo<BasketResponse>("");
  const [CodeBarra, setCodeBarra] = useState<OrderBuyResponse[]>([]);
  const [loading, setLoading] = useState(true);

  // 1. Cuando tengamos respuesta del carrito, construimos el checkout
  useEffect(() => {
    //console.log("dataInformation : => ", dataInformation);
    
    if (!isLoadings && dataInformation?.status === 200) {
      const responseData: OrderBuyResponse = JSON.parse(
        dataInformation.message
      );
      //guardamos la respuesta en el state
      setCodeBarra([responseData]);
      setLoading(isLoadings);
    }
  }, [isLoadings, dataInformation]);

  const checkoutBuySku = "/CheckoutCart";
  return {
    CodeBarra,
    isLoadingCeckout: loading || isLoadings,
    postData,
    checkoutBuySku,
  };
};

export const useTicketOrderBuyV2 = (
  isLoadinLoad: boolean,
  formData: MBuyCarCheckout,
  addTicketProduct: MBasket[]
) => {
  const {
    data: response,
    loading: isPosting,
    postData,
  } = useFunctionInfo<BasketResponse>("");
  const [CodeBarra, setCodeBarra] = useState<OrderBuyResponse[]>([]);
  const [loading, setLoading] = useState(true);

  // console.log(
  //   `isLoadinLoad => ${isLoadinLoad} \n & formData => ${JSON.stringify(
  //     formData
  //   )} \n & addTicketProduct => ${JSON.stringify(addTicketProduct)}`
  // );
  // 1. Cuando tengamos el proceso de la orden de compra
  useEffect(() => {
    if (!isLoadinLoad && formData && addTicketProduct?.length > 0) {
      const dataPdp: BuyProduct = {
        skuId:
          addTicketProduct
            .flatMap((x) => x.item_id)
            .filter(Boolean)
            .join(",") ?? "",
        productItems: addTicketProduct,
      };

      const MBasket_MFormData: MBuyFrom = {
        dataPdp: dataPdp,
        formData: formData,
      };

      postData("/CheckoutCart", MBasket_MFormData);
    }
  }, [isLoadinLoad, formData, addTicketProduct, postData]);

  // 2. Cuando tengamos respuesta del carrito, construimos el checkout
  useEffect(() => {
    // console.log(
    //   "resultado de CodeBarra",
    //   CodeBarra,
    //   " -- isPosting --",
    //   isPosting,
    //   " // -- response ",
    //   response
    // );
    if (!isPosting && response?.status === 200) {
      const responseData: OrderBuyResponse = JSON.parse(response.message);
      setCodeBarra([responseData]);
      setLoading(false);
    }
  }, [isPosting, response]);

  return {
    mDatos: CodeBarra,
    isLoadingCeckout: loading || isPosting,
  };
};

export const useCheckoutCart = () => {
  const { postData } = useFunctionInfo<any>("");
  const checkoutBuySku = "/CheckoutCart";
  return {
    postData,
    checkoutBuySku,
  };
};

export const useDeleteOrderBuy = (skuId: string) => {
  const { loading: isLoadings, postData: deleteData } =
    useFunctionInfo<any>("");

  const [loading] = useState(true);

  const eliminarOrderBuySku = `/DeleteCart?sku=${skuId}`;
  return {
    isLoadingEliminar: loading || isLoadings,
    deleteData,
    eliminarOrderBuySku,
  };
};
